import React from 'react'
import styled from 'styled-components/macro'
import OllieAskLink from 'src/components/ollie/OllieAskLink'
import useOllieAtLimit from 'src/hooks/useOllieAtLimit'
import { resolveProgressAskOllie } from 'src/utils/growthEngineProgressAskOllie'

/**
 * One Ask Ollie line on a Progress job landing — help in the path if they stall.
 * Hidden at the Ollie message limit: the drafted question could not be sent.
 */
const GrowthEngineProgressAskOllie = ({
  featureId,
  fromHub = null,
  enabled = true,
  className,
  'data-testid': dataTestId = 'progress-landing-ask-ollie',
}) => {
  const atLimit = useOllieAtLimit()
  if (!enabled || atLimit) return null
  const askOllie = resolveProgressAskOllie(featureId, fromHub)
  if (!askOllie) return null

  return (
    <Wrap className={className} data-testid={dataTestId}>
      <OllieAskLink question={askOllie.question} label={askOllie.label} />
    </Wrap>
  )
}

const Wrap = styled.div`
  width: 100%;

  button {
    margin: 0 0 12px;
  }
`

export default GrowthEngineProgressAskOllie
